import { useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router";
import Loading from "../components/Loading";

export default function TecelagemRoutes() {
    const auth = useAuth();
    if(auth.loading) {
        return (
            <Loading />
        )
    }
    return auth.user.role === 'producao' || auth.user.role === 'admin' || auth.user.role === 'manutencao' ? <Outlet /> : <Navigate to="/" />
}